export const READER_PROCESSOR_VERSION = 'reader-v1'
export const DEFAULT_MAX_WORD_LENGTH = 6
